<script lang="ts">
  import { PlayerComplexity } from '../models/player.type';

  interface Props {
    level: PlayerComplexity | undefined;
  }

  let { level }: Props = $props();

  const levels = [PlayerComplexity.Simple, PlayerComplexity.Moderate, PlayerComplexity.Complex];

  let rank = $derived(level ? levels.indexOf(level) + 1 : 0);
</script>

<div class="difficulty {level?.toLowerCase()}" aria-label="Difficulty: {level}">
  {#each levels as _, index}
    <span class="pip" class:filled={index < rank}></span>
  {/each}
  <span class="label">{level}</span>
</div>

<style lang="less">
  @import '../../defines.less';

  .difficulty {
    --tone: @gray;

    display: inline-flex;
    align-items: center;
    gap: 5px;
    font-size: clamp(14px, 1.9vh, 18px);
    color: var(--tone);

    &.simple {
      --tone: @green;
    }
    &.moderate {
      --tone: @yellow;
    }
    &.complex {
      --tone: @red;
    }
  }

  .pip {
    width: 0.6em;
    height: 0.6em;
    border-radius: 50%;
    border: 1px solid var(--tone);
    box-shadow: 0 1px 2px black;

    &.filled {
      background: var(--tone);
    }
  }

  .label {
    margin-left: 4px;
    font-size: 0.85em;
    letter-spacing: 0.12em;
    text-transform: uppercase;
  }
</style>
